import { gql } from '@apollo/client';

export const DUALMATCHES = gql`
  query dualMatches($seasonStarting: String!) {
    dualMatches(seasonStarting: $seasonStarting) {
      id
      contextualInfo {
        result
        didWin
        homeTeam
        thisTeam {
          name
          id
        }
        opponent {
          name
          id
          logo {
            url
            width
          }
        }
      }
      startDateTime {
        timezoneName
        noScheduledTime
        dateTimeString
      }
      homeTeam {
        name
        id
      }
      teams {
        name
        id
      }
      location
      scoringFormat
      isConferenceMatch
      isNeutralLocation
      webLinks {
        name
        url
      }
    }
  }
`;
